import { create } from "zustand";

interface FocusState {
  focusedIssueId: string | null;
  lastFocusedIssueId: string | null;
  setFocusedIssue: (issueId: string | null) => void;
  setLastFocusedIssue: (issueId: string | null) => void;
  clearFocus: () => void;
}

export const useFocusStore = create<FocusState>((set) => ({
  focusedIssueId: null,
  lastFocusedIssueId: null,
  setFocusedIssue: (issueId: string | null) => {
    set({ focusedIssueId: issueId });
  },
  setLastFocusedIssue: (issueId: string | null) => {
    set({ lastFocusedIssueId: issueId });
  },
  clearFocus: () => {
    set({ focusedIssueId: null });
  },
}));
